// extracted by mini-css-extract-plugin
export var footer = "_pt-0";
export var inherit = "_pt-1";
export var input = "_pt-2";
export var modalContent = "_pt-3";
export var quillEditor = "_pt-4";
export var subtitle = "_pt-5";